import type {AriaTextFieldOptions} from 'react-aria';
import {useTextField} from 'react-aria';
import React, {useRef} from "react";


export function TextField(props: AriaTextFieldOptions<"input">) {

    const {label, isRequired, isDisabled} = props;
    const ref = useRef(null);
    const {
        labelProps,
        inputProps,
        descriptionProps,
        errorMessageProps,
        isInvalid,
        validationErrors
    } = useTextField(props, ref);

    return (
        <div>
            {label && (
                <label {...labelProps} className={`field-label ${isDisabled ? 'field-disabled' : ''}`}>
                    {label}
                    {isRequired && <span className={'field-required'}>*</span>}
                </label>
            )}

            <div className={`field-container ${isDisabled ? 'field-disabled' : ''}`}>
                <input {...inputProps} ref={ref} className={'field-input'} />
            </div>

            {props.description && (
                <div {...descriptionProps} className={'mt-2 text-xs'}>
                    {props.description}
                </div>
            )}

            {isInvalid && (
                <div {...errorMessageProps} className={'field-error'}>
                    {validationErrors.join(' ')}
                </div>
            )}
        </div>
    );
}